import { EngineReportDetails, HydraulicOilPressureVm } from '@navstation-portal/reporting/data-model/engine-report';
import { getRangeTooltip, isOutOfRange } from '../range-tooltip.utils';

const MIN_PRESSURE = 0;

export function buildHydraulicOilPressureVm(details: EngineReportDetails | undefined): HydraulicOilPressureVm {
  const pumpInletOutOfRange = isOutOfRange(details?.pumpInlet, { min: MIN_PRESSURE });
  const pumpInletTooltip = getRangeTooltip('Pump Inlet', { min: MIN_PRESSURE }, 'bar');

  const mainPressureOutOfRange = isOutOfRange(details?.mainPressure, { min: MIN_PRESSURE });
  const mainPressureTooltip = getRangeTooltip('Main Pressure', { min: MIN_PRESSURE }, 'bar');

  return {
    pumpInletOutOfRange,
    pumpInletTooltip,
    mainPressureOutOfRange,
    mainPressureTooltip,
  };
}
